import googleAnalytics from 'shared/lib/googleAnalytics';
import { GA_USERPORTAL } from 'shared/constants';

export default googleAnalytics(GA_USERPORTAL);
